import React, { useEffect } from 'react';
import { ROICalculator } from '../../pages/ROICalculator';

// Hosts the ROI calculator as a deck slide. The calculator itself is copied
// unchanged; this wrapper only adapts it to the deck: Manrope type, and
// keeping the browser tab titled "D2D HIRE" (the calculator renames it on
// mount, and a parent effect runs after its children's).
export function Slide_Calculator() {
  useEffect(() => {
    document.title = 'D2D HIRE';
  }, []);
  return <div className="deck-calculator w-full font-manrope" data-id="element-1401" data-mp="1vd6231h5rcwf">
      <ROICalculator data-id="element-1402" data-mp="1zhdtj6f036yc" />
    </div>;
}